import React from 'react'
import { IconButton } from '@ui'

import { TouchNavBar } from 'components/TouchNavBar/TouchNavBar'

type Props = {
    title: string | React.ReactNode
    rightBarButton?: React.ReactNode
    onBack?: () => void
    noBackground?: boolean
}
export const TouchPanelNavigationBar = (props: Props) => {
    return (
        <TouchNavBar
            noBackground={props.noBackground}
            contentLeft={
                props.onBack ? (
                    <IconButton icon="back" size="square_md" onClick={props.onBack} />
                ) : undefined
            }
            contentRight={props.rightBarButton}
        >
            {props.title}
        </TouchNavBar>
    )
}
